import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPathPayload } from '@hwm/ui-lib';
import { AxiosResponse } from 'axios';
import { AccountModel } from '@api-model/account';
import { httpClient } from '@infrastructure/http/HttpClient';
import { apiPaths } from '@infrastructure/http/apiPaths';

const fetchSubaccounts = createAsyncThunk(
  `accounts/fetchSubaccounts`,
  async (params: getPathPayload<typeof apiPaths.accounts.subaccounts>) => {
    const response: AxiosResponse<AccountModel[]> = await httpClient.get(apiPaths.accounts.subaccounts(params));

    return response.data;
  }
);

export const accountsThunks = { fetchSubaccounts };
